<style lang="scss">
.notfind {
  background: rgba(20, 128, 227, 0.7);
  text-align: center;
  width: 100%;
  border-top: 1px solid #1480e3;
  height: 100%;
  img {
    margin-top: 15%;
  }
  a {
    display: block;
    margin-top: 10%;
  }
}
</style>
<template>
  <div class="notfind">
    <img
      :src="require('@/assets/img/public/404-1.svg')"
      alt=""
    >
    <router-link to="/">
      <el-button>返回首页</el-button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {}
  },
  created () {},
  methods: {}
}
</script>
